const ROOT = '/collateral-property';

const propertyPaths = {
  login: `${ROOT}/login`,
  register: (ref: string) => `${ROOT}/register/${ref}`,
  forgotPassword: `${ROOT}/forgot-password`,
  verifyPassword: `${ROOT}/verify-password`,
  cabinet: {
    root: `${ROOT}/cabinet`,
    profile: `${ROOT}/cabinet/profile`,
    resetEmail: `${ROOT}/cabinet/profile/reset-email`,
    application: `${ROOT}/cabinet/application`,
    reports: `${ROOT}/cabinet/reports`,
  },
};

export default propertyPaths;
